import { render, staticRenderFns } from "./DocumentsStatusFilter.vue?vue&type=template&id=6fb893fe&scoped=true&"
import script from "./DocumentsStatusFilter.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./DocumentsStatusFilter.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./DocumentsStatusFilter.vue?vue&type=style&index=0&id=6fb893fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb893fe",
  null
  
)

export default component.exports